<template>
  <GlobalWindow
    :title="title"
    :visible.sync="visible"
    :confirm-working="isWorking"
    :withFooter="false"
  >
    <div class="com" v-if="info">
      <div class="com_image">
        <img :src="info.fullLog" />
      </div>
      <div class="com_info">
        <div class="com_info_title">{{info.name}}</div>
        <div class="com_info_list">
          <div class="com_info_list_item">
            <div class="com_info_list_item_label">行业类别：</div>
            <div class="com_info_list_item_val">{{info.industryName}}</div>
          </div>
          <div class="com_info_list_item">
            <div class="com_info_list_item_label">服务商星级：</div>
            <div class="com_info_list_item_val">
              <el-rate v-model="info.starLevel" :colors="['#FF934D','#FF934D','#FF934D']" disabled text-color="#ff9900"></el-rate>
            </div>
          </div>
          <div class="com_info_list_item">
            <div class="com_info_list_item_label">联系人：</div>
            <div class="com_info_list_item_val">{{info.linkName}}</div>
          </div>
          <div class="com_info_list_item">
            <div class="com_info_list_item_label">联系方式：</div>
            <div class="com_info_list_item_val">{{info.linkPhone}}</div>
          </div>
          <div class="com_info_list_item">
            <div class="com_info_list_item_label">企业介绍：</div>
            <div class="com_info_list_item_val">{{info.introduction}}</div>
          </div>
        </div>
      </div>
    </div>
  </GlobalWindow>
</template>

<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalWindow from '@/components/common/GlobalWindow'
import { getById } from '@/api/business/serverProvider'
export default {
  name: 'OperaDemandRecordWindow',
  extends: BaseOpera,
  components: { GlobalWindow },
  data () {
    return {
      value: 4,
      info: null
    }
  },
  methods: {
    async open (title, id) {
      this.title = title
      this.info = await getById(id)
      this.visible = true

    }
  }
}
</script>

<style lang="scss" scoped>
  .com {
    width: 100%;
    display: flex;
    .com_image {
      width: 140px;
      height: 140px;
      flex-shrink: 0;
      background: #F4F7FC;
      margin-right: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      img {
        width: 100%;
      }
    }
    .com_info {
      flex: 1;
      display: flex;
      flex-direction: column;
      .com_info_title {
        font-weight: 600;
        font-size: 26px;
        color: #222222;
        margin-bottom: 20px;
      }
      .com_info_list {
        display: flex;
        flex-direction: column;
        .com_info_list_item {
          width: 100%;
          display: flex;
          margin-bottom: 30px;
          .com_info_list_item_label {
            font-weight: 400;
            font-size: 16px;
            color: #666666;
            flex-shrink: 0;
          }
          .com_info_list_item_val {
            flex: 1;
            font-weight: 400;
            font-size: 16px;
            color: #333333;
          }
        }
      }
    }
  }
</style>
